/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Hero_Perfectgames1Inputs */

const id_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game sempurna`)
};

const ms_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permainan sempurna`)
};

const da_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfekte spil`)
};

const de_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfekte Spiele`)
};

const en_us2_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfect games`)
};

const es_es2_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos perfectos`)
};

const es_mx2_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos perfectos`)
};

const fil_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perpektong laro`)
};

const fr_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeux parfaits`)
};

const it_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giochi perfetti`)
};

const hu_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tökéletes játékok`)
};

const nl_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfecte games`)
};

const no_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfekte spill`)
};

const pl_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idealne gry`)
};

const pt_br2_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos perfeitos`)
};

const pt_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos perfeitos`)
};

const ro_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jocuri perfecte`)
};

const fi_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Täydelliset pelit`)
};

const sv_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfekta spel`)
};

const vi_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game hoàn hảo`)
};

const tr_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mükemmel oyunlar`)
};

const cs_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfektní hry`)
};

const bg_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перфектни игри`)
};

const ru_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Идеальные игры`)
};

const uk_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ідеальні ігри`)
};

const ar_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ألعاب مثالية`)
};

const hi_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परफ़ेक्ट गेम`)
};

const th_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกมที่สมบูรณ์แบบ`)
};

const ja_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーフェクトゲーム`)
};

const zh_cn2_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完美游戏`)
};

const zh_hant1_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完美遊戲`)
};

const ko_profile_hero_perfectgames1 = /** @type {(inputs: Profile_Hero_Perfectgames1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`완벽한 게임`)
};

/**
* | output |
* | --- |
* | "Perfect games" |
*
* @param {Profile_Hero_Perfectgames1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_hero_perfectgames1 = /** @type {((inputs?: Profile_Hero_Perfectgames1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Hero_Perfectgames1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_hero_perfectgames1(inputs)
	if (locale === "ms") return ms_profile_hero_perfectgames1(inputs)
	if (locale === "da") return da_profile_hero_perfectgames1(inputs)
	if (locale === "de") return de_profile_hero_perfectgames1(inputs)
	if (locale === "en-US") return en_us2_profile_hero_perfectgames1(inputs)
	if (locale === "es-ES") return es_es2_profile_hero_perfectgames1(inputs)
	if (locale === "es-MX") return es_mx2_profile_hero_perfectgames1(inputs)
	if (locale === "fil") return fil_profile_hero_perfectgames1(inputs)
	if (locale === "fr") return fr_profile_hero_perfectgames1(inputs)
	if (locale === "it") return it_profile_hero_perfectgames1(inputs)
	if (locale === "hu") return hu_profile_hero_perfectgames1(inputs)
	if (locale === "nl") return nl_profile_hero_perfectgames1(inputs)
	if (locale === "no") return no_profile_hero_perfectgames1(inputs)
	if (locale === "pl") return pl_profile_hero_perfectgames1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_hero_perfectgames1(inputs)
	if (locale === "pt") return pt_profile_hero_perfectgames1(inputs)
	if (locale === "ro") return ro_profile_hero_perfectgames1(inputs)
	if (locale === "fi") return fi_profile_hero_perfectgames1(inputs)
	if (locale === "sv") return sv_profile_hero_perfectgames1(inputs)
	if (locale === "vi") return vi_profile_hero_perfectgames1(inputs)
	if (locale === "tr") return tr_profile_hero_perfectgames1(inputs)
	if (locale === "cs") return cs_profile_hero_perfectgames1(inputs)
	if (locale === "bg") return bg_profile_hero_perfectgames1(inputs)
	if (locale === "ru") return ru_profile_hero_perfectgames1(inputs)
	if (locale === "uk") return uk_profile_hero_perfectgames1(inputs)
	if (locale === "ar") return ar_profile_hero_perfectgames1(inputs)
	if (locale === "hi") return hi_profile_hero_perfectgames1(inputs)
	if (locale === "th") return th_profile_hero_perfectgames1(inputs)
	if (locale === "ja") return ja_profile_hero_perfectgames1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_hero_perfectgames1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_hero_perfectgames1(inputs)
	return ko_profile_hero_perfectgames1(inputs)
});
export { profile_hero_perfectgames1 as "profile.hero.perfectGames" }